// Client-side frame compositor (Local Engine Phase 2).
// Composites a decoded video frame + CaptionMotion caption layers into a canvas,
// reusing the SAME drawing code (animator.js) that powers the editor preview, so
// on-device preview and on-device export look identical. Canvas2D drawImage is
// already GPU-backed by the browser; a dedicated WebGL/WebGPU path is a later
// optimization and would slot in behind this same function signature.

import { drawCaptionFrame, drawFrame, hasAnyCaptionObjects } from "@/lib/animator";

export function makeCanvas(w, h) {
  if (typeof OffscreenCanvas !== "undefined") return new OffscreenCanvas(w, h);
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  return c;
}

// Cover-fit the source frame into W×H (matches the server export's scale+crop).
export function drawVideoCover(ctx, video, W, H) {
  const vw = video.videoWidth || video.width || W;
  const vh = video.videoHeight || video.height || H;
  if (!vw || !vh) { ctx.fillStyle = "#000"; ctx.fillRect(0, 0, W, H); return; }
  const scale = Math.max(W / vw, H / vh);
  const dw = vw * scale, dh = vh * scale;
  ctx.drawImage(video, (W - dw) / 2, (H - dh) / 2, dw, dh);
}

// Composite one frame at time t. `video` may be null (solid background).
export function compositeFrame(ctx, video, t, W, H, { layers, config, segments } = {}) {
  if (video) drawVideoCover(ctx, video, W, H);
  else { ctx.fillStyle = "#000"; ctx.fillRect(0, 0, W, H); }
  // Caption overlay (transparent) — same renderer as the live preview.
  if (hasAnyCaptionObjects(layers)) drawCaptionFrame(ctx, t, W, H, layers, config, segments, { noClear: true });
  else if (segments && segments.length) drawFrame(ctx, t, W, H, segments, config, { noClear: true });
}
